const START_WATCH_LOADING_STATUS = 'startWatchLoadingStatus';
const FINISH_LOAD_GAME = 'finishLoadGame';
const CHECK_GAME_STATUS = 'checkGameStatus';
const END_CHECKING_GAME_STATUS = 'endCheckingGameStatus';
const STOP_GAME = 'stopGame';
const START_GAME = 'startGame';

const SET_ID_TIMER = 'setIdTimer';
const SET_GAME_STATUS = 'setGameStatus';
const SET_LOADING_STATUS = 'setLoadingStatus';
const SET_CLEAR_TIOMEOUT = 'setClearTimeout';


const state = {
    gameIsActive: true,
    loadingComplete: false,
    idTimer: null
};

const getters = {
    gameIsActive: state => state.gameIsActive
};

const actions = {
    [CHECK_GAME_STATUS]: ({ state, dispatch, commit }, resolve) => {
        if (state.loadingComplete) {
            resolve();
            return;
        }
        const idTimer = setTimeout(() => {
            dispatch(CHECK_GAME_STATUS, resolve);
        }, 500);
        commit(SET_ID_TIMER, idTimer);
    },
    [START_WATCH_LOADING_STATUS]: async ({ dispatch }) => {
        await new Promise((resolve) => {
            dispatch(CHECK_GAME_STATUS, resolve);
        });
    },
    [FINISH_LOAD_GAME]: ({ commit }) => {
        commit(SET_LOADING_STATUS, true);
    },
    [END_CHECKING_GAME_STATUS]: ({ commit }) => {
        commit(SET_CLEAR_TIOMEOUT);
    },
    [STOP_GAME]: ({ commit }) => {
        commit(SET_GAME_STATUS, false);
        commit(SET_LOADING_STATUS, false);
    },
    [START_GAME]: async ({ commit, dispatch }) => {
        commit(SET_GAME_STATUS, true);
        await dispatch(START_WATCH_LOADING_STATUS);
    },
};

const mutations = {
    [SET_GAME_STATUS](state, gameStatus) {
        state.gameIsActive = gameStatus;
    },
    [SET_LOADING_STATUS](state, loadingStatus) {
        state.loadingComplete = loadingStatus;
    },
    [SET_ID_TIMER](state, idTimer) {
        state.idTimer = idTimer;
    },
    [SET_CLEAR_TIOMEOUT](state) {
        clearTimeout(state.idTimer);
        state.idTimer = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./skins/xkiosk/data/game-on-loading.js